module.exports = __webpack_public_path__ + "static/RobotoMono-Bold-04cdeeec5a07892821d122b4eb1a0652.woff";